"use client"

import React, { ReactNode, useEffect } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { SEARCH_PARAMS_PAGE } from "@/constants/ui"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { AccountContext } from "@/lib/storefront/account/account-service"
import { DataPagination } from "@/components/ui/components/data-pagination"
import { getPaginationSearchParams } from "@/components/search-and-category/pagination-info"
import SearchResultPageSizeClient from "@/components/search-and-category/SearchResultPageSizeClient"
import SearchResultPaginationClient from "@/components/search-and-category/SearchResultPaginationClient"

interface AccountOrderListClientsProps {
  accountContext: AccountContext
  pageSize: number
  pageNumber: number
  productCards: ReactNode[]
  productsTotal: number
}

export default function AccountArticleListClient(props: AccountOrderListClientsProps) {
  const searchParams = useSearchParams()
  const paginationSearchParams = getPaginationSearchParams(searchParams ?? undefined, true)
  const { push } = useRouter()
  const { setIsLoading } = useUbStorefrontState()

  async function getPagedProducts(page: number) {
    const params = new URLSearchParams(searchParams)
    params.set(SEARCH_PARAMS_PAGE, page.toString())
    setIsLoading(true)
    push(`?${params.toString()}`)
  }

  useEffect(() => {
    setIsLoading(false)
  }, [searchParams, setIsLoading])

  return (
    <>
      <div className={"relative flex w-full flex-col gap-4"}>
        <div className="flex w-full flex-row justify-start @container">
          <div className={"max-sm:hidden"}>
            <SearchResultPageSizeClient productsTotal={props.productsTotal} accountArticlesMode={true} />
          </div>
          <div className={"flex w-4/5 flex-row justify-center max-sm:w-full max-sm:justify-center "}>
            <SearchResultPaginationClient
              productsTotal={props.productsTotal}
              searchParams={searchParams}
              paginationSearchParams={paginationSearchParams}
            />
          </div>
        </div>

        <div className={"grid grid-cols-1 gap-4 lg:grid-cols-3"}>{props.productCards}</div>

        <DataPagination
          initialPage={props.pageNumber}
          totalPages={Math.ceil(props.productsTotal / props.pageSize)}
          onPageChange={(page) => getPagedProducts(page)}
        ></DataPagination>
      </div>
    </>
  )
}
